import { useCallback } from 'react';
import { useGetCurrentOrganization } from '@/api/trafikportalen';
import { hasHalfProductDiscountCode } from '@/helpers/halfProduct';
import { useTenantConfiguration } from '@/hooks/useTenantConfiguration';
import { useAuth } from '@/stores/auth';
import type { StudentType } from '@/types/students';

export const useHalfProductAvailability = () => {
  const { disableHalfProduct } = useTenantConfiguration();
  const hasOrganization = useAuth((state) =>
    Boolean(state.userProfile?.organization_id),
  );
  const { data: organization } = useGetCurrentOrganization({
    query: { enabled: hasOrganization },
  });

  return useCallback(
    (studentType: StudentType) =>
      !disableHalfProduct &&
      hasHalfProductDiscountCode(organization?.discount_codes, studentType),
    [disableHalfProduct, organization?.discount_codes],
  );
};
